import React from "react";
import I18n from "../../../i18n";
import ReportAction from "../../../actions/ReportAction";
import { StressGenericList, getExportAll, getExportComparePromise } from "./index";
import { StressTestSupportGraph } from "../../../constants/supportGraph";

export default (props)=><StressGenericList
	getExportAll={getExportAll}
	// getExportComparePromise={getExportComparePromise}
	subHeader={I18n.t("stress_level_overview")}
	fetchMain={ReportAction.fetchStressOverview}
	headKeys={[StressTestSupportGraph.Frequency]}
/>;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/StressUsageOverview.js